import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';

import './sidebar.css';

const navItems = [
	{
		icon: 'home',
		link: '/',
		text: 'Home',
	},
	{
		icon: 'insert_drive_file',
		link: '/my-files',
		text: 'My Files',
	},
	{
		icon: 'sms_failed',
		link: '/notifications',
		text: 'Notifications',
	},
	{
		icon: 'attach_money',
		link: '/distributions',
		text: 'Distributions',
	},
	{
		icon: 'person',
		link: '/settings',
		text: 'Settings',
	},
]

const Sidebar = ({ onLogoutClick, onNavClick }) => {
	return (
		<div className="sidebar">
			<Link className="sidebar__title" to="/">Dale Operating Company</Link>
			<ul className="sidebar__list">
				{
					navItems.map(item => {
						return (
							<li key={item.text} className="sidebar__item">

								<NavLink
									exact
									className="sidebar__link"
									activeClassName="sidebar__link--active"
									to={item.link}
									onClick={onNavClick}>
									<span className="sidebar__icon material-icons">{item.icon}</span>
									<span className="sidebar__text">{item.text}</span>
								</NavLink>

							</li>
						);
					})
				}
			</ul>
			<span className="sidebar__link sidebar__link--logout" onClick={onLogoutClick}>
				<span className="sidebar__icon material-icons">power_settings_new</span>
				<span className="sidebar__text">Logout</span>
			</span>
		</div>
	);
};

Sidebar.propTypes = {
	onLogoutClick: PropTypes.func.isRequired,
	onNavClick: PropTypes.func.isRequired,
}

export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js